module.exports = __webpack_public_path__ + "static/media/SE_EXTC_Syllabus.41b0064e.pdf";